<template>
  <div
    class="bg-white relative rounded-2xl border grid gap-2 pb-2 shadow-md overflow-hidden"
  >
    <Post
      :class="{ lock: data.is_fake }"
      :data="data"
      :isCollection="isCollection"
    />
  </div>
</template>

<script>
import Post from "./Post";

export default {
  components: {
    Post,
  },
  props: {
    data: Object,
    isCollection: Boolean,
    unlock: Boolean,
  },
};
</script>

<style>
.lock {
  filter: blur(12px);
  pointer-events: none;
}
</style>
